import * as React from "react";
import { Fragment } from "react";
import { Box, Flex, GridItem, Text } from "@chakra-ui/react";
import NumberField from "../../../../../../components/NumberField/NumberField";
import { MEASURES, POWER_SOURCES } from "../../../../../OrganizationQuestionnaire/helpers";
import { MissingDataGridItems } from "../../MissingDataGridItems";
import { dataTypeColours } from "../../ByDimensionReport/components/helpers";
import { isBiogenic } from "utils/carbon-utils";

/**
 * Makes an array of 3xGridItems (which should render in rows)
 * TODO refactor
 */
function TotalEmissionsGridItems({ data, sectionItems, dataType }) {

	const getDataObject = (sectionItem) => {
		return dataType === "electricity" ?
			data[dataType].items.find(source => source.consumptionType.code === sectionItem) :
			data[dataType].items.find(source => source.consumptionType.code === sectionItem.code);
	}
	// skip blanks
	sectionItems = sectionItems.filter(sectionItem => sectionItem && getDataObject(sectionItem));
	if (sectionItems.length === 0) {
		return [<MissingDataGridItems key={`${dataType}-missing`} value={0} />];
	}
	const biogenicSections = sectionItems.filter(sectionItem => isBiogenic(sectionItem));
	const nonBiogenicSections = sectionItems.filter(sectionItem => !isBiogenic(sectionItem));
	const section = [];

	nonBiogenicSections.forEach(sectionItem => addSectionItem({sectionItem, section, dataObject:getDataObject(sectionItem), dataType}));
	if (biogenicSections.length > 0) {
		section.push(<Fragment key='biogenic-separator'><GridItem colSpan={3}>Biogenic items (CO<sub>2</sub> not included in Scope 1 total)</GridItem></Fragment>);
		// Note Co2 not CO2e. 
		// TODO how do we handle non-CO2 gases? They should be included in the Scope 1 total for biogenic items
	}
	biogenicSections.forEach(sectionItem => addSectionItem({sectionItem, section, dataObject:getDataObject(sectionItem), dataType}));

	return section;
} // ./TotalEmissionsGridItems


function addSectionItem({sectionItem, section, dataObject, dataType}) {
	let subTitle = "";
	if (dataObject.itemsPerMeasures.length === 1) {
		// The consumption for the current item has only one measuring unit,
		// so we are showing the unit (as subTitle) next to the item name, and we do not add any sub items
		const measureName = MEASURES[dataObject.itemsPerMeasures[0].measure.code] ?? dataObject.itemsPerMeasures[0].measure.name;
		subTitle = ` (${measureName})`;
	}

	const consumptionItemName = dataType === "electricity" ?
		POWER_SOURCES[sectionItem] ?? sectionItem :
		POWER_SOURCES[sectionItem?.code] ?? sectionItem?.name ?? sectionItem?.code;

	// Adding group header row
	section.push(<Fragment key={`header-row-${sectionItem.code ?? sectionItem}`}>
		<GridItem>
			<Flex gap="3" inlineSize="305px" alignItems={"center"}>
				<Box
					width={3}
					height={3}
					backgroundColor={dataTypeColours[dataType]}
					borderRadius={"50%"}
					display={"inline-block"}
				/>
				<Box
					display="flex"
					alignItems="center"
					fontSize="sm"
					whiteSpace="break-spaces">
					<Text>
						<b>{consumptionItemName}</b>{subTitle ? subTitle : ""}
					</Text>
				</Box>
			</Flex>
		</GridItem>
		<GridItem display="flex" justifyContent="end" textAlign="right" alignItems="center">
			{dataObject.itemsPerMeasures.length === 1 ?
				<NumberField value={dataObject.itemsPerMeasures[0].consumption} /> : "-"
			}
		</GridItem>
		<GridItem display="flex" justifyContent="end" alignItems="center">
			<NumberField value={dataObject.co2Emissions} fontWeight="bold" />
		</GridItem>
	</Fragment>);

	if (dataObject.itemsPerMeasures?.length < 2) {
		// if one row - no need for sub-rows
		return
	}
	// Adding sub items for all consumptions > 0, each on separate row
	section.push(dataObject.itemsPerMeasures.map(measureItem => 
		<EmissionsGridRow key={`${dataType}-${sectionItem.code ?? sectionItem}-${measureItem.measure.id}`} measureItem={measureItem} />));
}


function EmissionsGridRow({ measureItem }) {
	return (<Fragment>
		<GridItem>
			<Box inlineSize="300px">
				<Text
					display="flex"
					justifyContent="start"
					alignItems="center"
					fontSize="sm"
					whiteSpace="break-spaces"
					marginLeft={6}
				>
					{MEASURES[measureItem.measure.code] ?? measureItem.measure.name}
				</Text>
			</Box>
		</GridItem>
		<GridItem>
			<NumberField value={measureItem.consumption} />
		</GridItem>
		<GridItem>
			<NumberField value={measureItem.co2Emissions} />
		</GridItem>
	</Fragment>);
}

export default TotalEmissionsGridItems;